import {Component, HostBinding, Input, OnChanges, OnDestroy,  SimpleChanges} from '@angular/core';
import {
    AbstractControl,
    ControlValueAccessor,
    UntypedFormBuilder,
    UntypedFormGroup,
    NG_VALIDATORS,
    NG_VALUE_ACCESSOR, ValidationErrors
} from "@angular/forms";
import {dataForm} from "../auto-complete-form/auto-complete-form.component";
import {getExtensionFile, typeFormValue} from "../../configurationProperty/configurationPropertyUtils";
import {Observable, of, Subscription} from "rxjs";
import {ImageService} from "../../providers/service/image.service";
import {DomSanitizer} from "@angular/platform-browser";
import {arrayIsSet, hunaParseFileName, stringIsSet} from "../../providers/service/global-variables.service";
import {isNotNullOrUndefined} from "../../providers/service/global-variables.service";
import {map} from "rxjs/operators";
import {SpecialButton} from "../key-values-field/key-values-field.component";
import {SensorDataTypesParse} from "../../ParseClass/sensor-data-types-parse";
import {ElementParse_v2} from "../../ParseClass/Element.Parse";

@Component({
    selector: 'app-get-form-field-from-configuration-file',
    templateUrl: './get-form-field-from-configuration-file.component.html',
    styleUrls: ['./get-form-field-from-configuration-file.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            multi: true,
            useExisting: GetFormFieldFromConfigurationFileComponent
        },
        {
            provide: NG_VALIDATORS,
            multi: true,
            useExisting: GetFormFieldFromConfigurationFileComponent
        }
    ],
    standalone: false
})
export class GetFormFieldFromConfigurationFileComponent implements OnChanges, OnDestroy, ControlValueAccessor {
    @Input() titleTraduction: string = '';
    @Input() possibleValues: dataForm[] | undefined;
    @Input() specialValues: SpecialButton | undefined;
    @Input() elements: ElementParse_v2[] | undefined;
    @Input() sensorsData: SensorDataTypesParse[] | undefined;
    @Input() idsUsed: string[] | undefined;
    @Input() type: typeFormValue | undefined;
    @Input() minDate: Date | undefined;
    // bounds of INPUT_NUMBER / INPUT_INTEGER, validated by the parent control
    @Input() min: number | undefined;
    @Input() max: number | undefined;
    @Input() visualizedClearButton = true;
    @Input() enableDisabelEmitEvent = true;
    @Input() iconPushButton: { icon: undefined | string, svgIcon: undefined | string } | undefined = {
        icon: undefined,
        svgIcon: undefined
    };
    @Input() isTouched: boolean | undefined;
    isTouched_: boolean | undefined;
    errorIsSet = false;

    public form: UntypedFormGroup;
    possibleValuesIsSet = false;
    visualizeImage = true;
    showCalendar = false;
    public iconPushButtonIsSet: boolean = false;
    private subScriptions: Subscription[] = [];
    private onChangeSubscription: Subscription | undefined;

    public typeForm = typeFormValue;

    // css class for each form type: huna-field--input-number, huna-field--elenco-vincolato, ...
    @HostBinding('class')
    get hostTypeClass(): string {
        const typeName = this.type != null ? typeFormValue[this.type] : undefined;
        return typeName ? `huna-field huna-field--${typeName.toLowerCase().replace(/_/g, '-')}` : 'huna-field';
    }

    constructor(
        private fb: UntypedFormBuilder,
        private imageService: ImageService,
        private _sanitizer: DomSanitizer,
    ) {
        this.form = this.fb.group({value: null});
        const sub = this.form.statusChanges.subscribe(status => {
                setTimeout(() => {
                    this.errorIsSet = this.form.get('value') != null && this.form.get('value')?.errors != null;
                });
            }
        );
        this.subScriptions.push(sub);
    }


    ngOnChanges(changes: SimpleChanges): void {
        if (changes.possibleValues != null) {
            this.possibleValuesIsSet = arrayIsSet(this.possibleValues);
        }
        if (changes.iconPushButton) {
            this.iconPushButtonIsSet = this.iconPushButton != null && (stringIsSet(this.iconPushButton.icon) || stringIsSet(this.iconPushButton.svgIcon))
        }
        if (changes.isTouched != null) {
            setTimeout(() => {
                this.isTouched_ = this.isTouched && this.type !== this.typeForm.PUSH_BUTTON;
            });
        }


    }

    getErrorByObject(errors: any): string {
        if (errors == null || (typeof errors !== 'object' && typeof errors !== 'string' && errors.toString == null)) {
            return '';
        }
        let errorMessage = '';
        const keys = Object.keys(errors);
        if (arrayIsSet(keys)) {
            keys.forEach((key, index) => {
                if (errors[key] != null) {
                    if (index !== 0) {
                        errorMessage += ' ';
                    }
                    errorMessage += key;
                    if (typeof errors[key] === 'object') {
                        errorMessage = ' ' + this.getErrorByObject(errors[key]);
                    } else if (typeof errors[key] === 'string') {
                        errorMessage += ' ' + errors[key];
                    } else if (errors[key].toString) {
                        errorMessage += ' ' + errors[key].toString();
                    }
                }
            });
        }
        return errorMessage;
    }

    ngOnDestroy(): void {
        this.onChangeSubscription?.unsubscribe();
        this.subScriptions.forEach(sub => sub.unsubscribe());
    }


    unsetValue() {
        this.form.get('value')?.reset();
    }

    unsetValueFile() {
        this.form.get('value')?.reset();
        this.form.get('value')?.markAsTouched();
    }


    minimizeImage() {
        this.visualizeImage = !this.visualizeImage;
    }

    onTouched: Function = () => {
    };


    // Angular calls this again when the directive is bound to another control: keep only the latest callback
    registerOnChange(onChange: any) {
        this.onChangeSubscription?.unsubscribe();
        this.onChangeSubscription = this.form.get('value')?.valueChanges
            .subscribe(onChange);
    }

    registerOnTouched(onTouched: Function) {
        this.onTouched = onTouched;
    }

    setDisabledState(disabled: boolean) {
        if (disabled) {
            this.form.disable({emitEvent: this.enableDisabelEmitEvent});
        } else {
            this.form.enable({emitEvent: this.enableDisabelEmitEvent});
        }
    }

    writeValue(value: any) {
        if (!isNotNullOrUndefined(value)) {
            this.form.get('value')?.reset();
        } else {
            this.form.get('value')?.setValue(value);
        }
    }

    validate(control: AbstractControl): ValidationErrors | null {
        if (!isNotNullOrUndefined(this.form.get('value')?.validator)) {
            this.form.get('value')?.setValidators(control.validator);
        }
        ;
        if (this.form.get('value')?.valid) {
            return null;
        } else {
            return this.form.get('value')?.errors!;
        }
        ;
    }


    getImageForForm(base64: string, nameNotParsed: string) {
        return this.imageService.compressImage(base64).then(compressed => {
            const base64Compressa: string = compressed as string;
            const url = () => {
                return this._sanitizer.bypassSecurityTrustUrl(base64Compressa);
            };
            const name = () => {
                // compressImage always re-encodes to JPEG
                return hunaParseFileName(nameNotParsed.replace(/\.[^./\\]*$/, '') + '.jpg');
            };
            return {
                url: url,
                file: base64Compressa,
                name: name
            };
            // this.salvaImage = true;
        });
    }

    onLoadImage(files: File[], label = 'value') {
        try {
            let fileUploadControl = files[0];
            if (files.length === 0) {
                // this.alertService.error(this.translate.instant('load_correct_file'));
            } else {
                if (fileUploadControl) {
                    const file = fileUploadControl;
                    const name = fileUploadControl.name;
                    const reader = new FileReader();
                    reader.onloadend = (e: ProgressEvent) => {
                        const base64 = (e.target as FileReader).result as any;
                        this.getImageForForm(base64, name).then(
                            (value) => {
                                this.form.get('value')?.setValue(value);
                                this.form.get('value')?.markAsTouched();
                            }
                        );
                    };
                    reader.onerror = (e) => {
                        // this.alertService.error(e)
                    };
                    reader.readAsDataURL(file);

                }
            }
        } catch (e) {
            console.error(e);
        }
    }

    onLoadFile(files: File[], label = 'value') {
        try {
            let fileUploadControl = files[0];
            const name = hunaParseFileName(fileUploadControl.name);
            const value = {name: name, file: fileUploadControl, ext: getExtensionFile(name)};
            this.form.get('value')?.markAsTouched();
            this.form.get('value')?.setValue(value);
        } catch (e) {
            console.error(e);
        }
    }

    isInError(keyError: string) {
        return this.form.touched && this.form.get('value')?.hasError(keyError);
    }

    get hasRange(): boolean {
        return this.min != null || this.max != null;
    }

    get rangeError(): boolean {
        const control = this.form.get('value');
        return !!control && (control.hasError('min') || control.hasError('max'));
    }

    // on blur, not while typing: clamping each keystroke would block typing multi-digit values
    clampToRange(): void {
        const control = this.form.get('value');
        const value = control?.value;
        if (!control || value === null || value === undefined || value === '' || isNaN(Number(value))) {
            return;
        }
        let clamped = Number(value);
        if (this.min != null && clamped < this.min) {
            clamped = this.min;
        }
        if (this.max != null && clamped > this.max) {
            clamped = this.max;
        }
        if (clamped !== Number(value)) {
            control.setValue(clamped);
        }
    }

    get imageIsSet() {
        return this.typeForm.IMAGE === this.type && isNotNullOrUndefined(this.form.get('value')) && isNotNullOrUndefined(this.form.get('value')?.value) && isNotNullOrUndefined(this.form.get('value')?.value.url);
    }

    get fileIsSet() {
        return this.typeForm.FILE === this.type && isNotNullOrUndefined(this.form.get('value')) && isNotNullOrUndefined(this.form.get('value')?.value) && isNotNullOrUndefined(this.form.get('value')?.value.file);
    }

    changeDate(event: Date) {
        this.form.get('value')?.setValue(event);
        this.form.get('value')?.markAsTouched();
        setTimeout(() => {
            this.showCalendar = false;
        }, 5);
    }

    changeLatLng(who: 'lat' | 'lng', event: any) {
        const value = this.form.get('value')?.value;
        value[who] = event.target.value;
        this.form.get('value')?.setValue(value);
        this.form.get('value')?.markAsTouched();
    }

    getValueLatLng(who: 'lat' | 'lng') {
        const value = this.form.get('value')?.value;
        return isNotNullOrUndefined(value) && isNotNullOrUndefined(value[who]) ? value[who] : 0
    }


    get isDisabled(): boolean {
        return this.form.get('value') != null && this.form.get('value')?.disabled === true;
    }

    get isDisableAsyncd(): Observable<boolean> {
        if (this.form.get('value') != null && this.form.get('value')?.statusChanges != null) {
            return this.form.get('value')?.statusChanges
                .pipe(
                    map(status => status === 'INVALID')
                ) as Observable<boolean>;
        } else {
            return of(false);
        }
    }

    clickCustomType(): void {
        const values = this.form.get('value')?.value;
        this.form.get('value')?.setValue({click: true, values: values});
        this.form.get('value')?.markAsTouched();
    }

    clickButton(): void {
        this.form.get('value')?.setValue(true);
        this.form.get('value')?.markAsTouched();
    }


}
